import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer'; 
import LazyLoad from 'react-lazyload';
const Pphelp = () => {
  useEffect(() => {
    document.title = 'Portal (Help?) -  Sacred Heart School, Ballia - U.P.';  
}, []); 
  return (
    <>
    <Header/>
    <section className="page-header"> 
        <div className="container">
        <div className="page-header__inner">
            <ul className="thm-breadcrumb list-unstyled ml-0">
                <li><Link to="/"> Home</Link></li>
                <li> Portal (Help?)  </li>
            </ul>
            <h2>Portal (Help?) </h2>
        </div>
        </div>
    </section>
    <section className="innerbody">
      <div className="container">
         <div className="row">
            <div className="col-md-12">
                 <h1 className="head1">CampusCare® Application Guidelines &amp; Instructions</h1>
                 <div class="erp_sec">
                 <p class="guideheading">How to LOG IN Parent Portal?</p>
                  <p class="details"> 1. Open Google Chrome <LazyLoad><img src="https://webapi.entab.info/api/image/SHSSB/public/Images/chrome.png"/> </LazyLoad>/ Mozilla Firefox <LazyLoad><img src="https://webapi.entab.info/api/image/SHSSB/public/Images/mzilla.png"/></LazyLoad> or Internet Explorer <LazyLoad><img src="https://webapi.entab.info/api/image/SHSSB/public/Images/internet.png"/></LazyLoad>. </p>
                  <p class="details"> 2. Write the school URL  <a href="https://shsb.campussoft.net/" class="parent-link" target="_blank"><strong>shsb.campussoft.net</strong></a> in address bar. (you will be routed to the Log In credential page).</p>
                  <p class="details"> 3. Then, select the Parent icon and enter the USER ID, PASSWORD and CAPTCHA CODE given below. Then press SIGN IN button.</p>
                  <p class="details"> Once logged in, you are welcomed with various information relating to assignments, news, Circulars, date sheet, fee details etc that are self explanatory.  Wish you to go through every links that are provided and explore more. </p>
     
                 <div class="clr10"></div>
      
                 <div>
                  <p class="guideheading">How to RESET PASSWORD in Parent Portal?</p>
                  <p class="details"> 1. Open Google Chrome <LazyLoad><img src="https://webapi.entab.info/api/image/SHSSB/public/Images/chrome.png"/></LazyLoad>/ Mozilla Firefox <LazyLoad><img src="https://webapi.entab.info/api/image/SHSSB/public/Images/mzilla.png"/></LazyLoad> or Internet Explorer<LazyLoad> <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/internet.png"/></LazyLoad>. </p>
                  <p class="details"> 2. Write the school URL  <a href="https://shsb.campussoft.net/" class="parent-link" target="_blank"><strong>shsb.campussoft.net</strong></a> in address bar. (you will be routed to the Log In credential page).</p>
                  <p class="details"> 3. After click on PARENTS menu, click on “Forgot password?” text given below the Sign In button.</p>
                  <p class="details"> 4. Enter Registered Mobile No. and click on  “Reset” Button.</p>
                  <p class="details"> 5. You will get an SMS on your registered mobile no. along with login credentials.</p>
                 </div>
                 <div class="clr25"></div>
     
                 
     
                    <div>
     
                  <div class="clr10"></div>
                  <p class="guideheading">How to make Online Payment ?</p>
                  <p class="details"> 1. Open Google Chrome <LazyLoad><img src="https://webapi.entab.info/api/image/SHSSB/public/Images/chrome.png"/></LazyLoad> / Mozilla Firefox <LazyLoad><img src="https://webapi.entab.info/api/image/SHSSB/public/Images/mzilla.png"/></LazyLoad> or Internet Explorer<LazyLoad> <img src="https://webapi.entab.info/api/image/SHSSB/public/Images/internet.png"/></LazyLoad>. </p>
                  <p class="details"> 2. Enter the school URL  <a href="https://shsb.campussoft.net/" class="parent-link" target="_blank"><strong>shsb.campussoft.net</strong> </a> in address bar and you will be routed to the Log In page. </p>
                  <p class="details">3. Now, enter the USER ID and then enter your PASSWORD and Click on ‘Sign in’ button.</p>
                  <p class="details"> 4. After login, click on the Online Payment menu. </p>
                 <p class="details"> 5. Select the installment to pay &amp; click on the proceed button.</p>
                 <p class="details"> 6. Now, you will be redirected to Payment Gateway page.</p>
                 <p class="details"> 7. Choose the Pay mode : Credit Card/Debit Card/Net banking &amp; fill the details to complete the payment process.</p>
                 <p class="details"> 8. After successful payment, you will receive the fee receipt &amp; SMS on successful fee payment.</p>
                 <p class="details"><em><strong>Note :</strong> If for any reason, the fee payment output details are not displayed on your screen after you have made payments, please check the details in “My Payment” in Finance link. If your accounts get debited/deducted and receipt is not available, you are advised to contact school office or mail us.</em></p>
                 </div>
                 <div class="clr10"></div>
                 
     
                    <div class="animated fadeInDown">
                            <p class="guideheading">How to Install and Operate MOBILE APP? </p>
                      <p class="details"> 1. Go to <LazyLoad><img src="https://webapi.entab.info/api/image/SHSSB/public/Images/playstore.png"/></LazyLoad> Store / <LazyLoad><img src="https://webapi.entab.info/api/image/SHSSB/public/Images/apple.png"/> </LazyLoad>and Search "CampusCare®". </p>
                      <p class="details"> 2. Install and open the app. </p>
                      <p class="details"> 3. Enter school web portal URL <strong><a target="_blank" href="https://shsb.campussoft.net/" class="parent-link">shsb.campussoft.net</a></strong> in link bar verify. </p>
                      <p class="details"> 4. After verifying, you will get an option for User ID &amp; Password.</p>
                      <p class="details"> Once logged in, you are welcomed with various information relating to assignments, news, circulars, date sheet, fee details etc that are self  Explanatory. Wish you to go through every links that are provided and explore more </p>
                      <p class="details"><em><strong>Note :</strong> Kindly update your mobile apps time to time to avoid difficulties during usage.</em> </p>
                    </div>
                    <div class="clr25"></div>
                  
                 <div class="assistance">
                  <p class="guideheading">Please call or write for assistance:</p>
                  <p class="details">PARENT HELP DESK (8:00 AM to 8:00 PM)  , E-Mail:  <a href="mailto:parentdesk@entab.in" class="parent-link"> parentdesk@entab.in</a></p>
                 </div>
                 <div class="clr25"></div>
              </div>
            </div>
         </div>
      </div>
</section>
 <Footer/>
   </>
  )
}

export default Pphelp